"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteListContainer = void 0;
exports.getKey = getKey;
exports.AutoCompleteListItems = AutoCompleteListItems;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var AutocompleteList_1 = require("./AutocompleteList");
var AutocompleteListItem_1 = require("./AutocompleteListItem");
var listItemHeight = 40;
// Peek: If there are enough items to require scrolling, we always make at least half
// of any item visible at the top or bottom. Otherwise, the user has no visual indication
// that there are items to be scrolled to, especially on mobile.
// Additional content buffer: This is a "lesser of two evils" work around for the lack of
// any reliable way to know the height of the virtual keyboard. We allow the user to scroll
// far enough to ensure that the last item can be seen. The drawback, of course, is that
// when a user has plenty of space (the view is not covered by the keyboard), you can
// scroll to the bottom and see a lot of whitespace.
// I think there are some possible alternatives, including the higher level control of page scrolling,
// generally caused by iOS Safari's SPA unfriendly fuckery, but all of the ones I can think of are
// either utterly insane or simply worse. We'll figure it out someday!
var getHeightForItemCount = function (count, maxVisibleItemCount) {
    if (maxVisibleItemCount === void 0) { maxVisibleItemCount = Infinity; }
    return listItemHeight * Math.min(count, maxVisibleItemCount);
};
var getLayoutHeights = function (resultCount, maxVisibleItemCount, basePadding, breakpoint) {
    var baseItemsHeight = getHeightForItemCount(resultCount, maxVisibleItemCount);
    var isDesktop = breakpoint === "large";
    var shouldPeek = resultCount > maxVisibleItemCount + 1;
    // Here, we ensure that if there is overflow, you will always see half of an item, above or below.
    // Half of the base padding is removed so that the peek is exactly centered.
    var peekHeight = shouldPeek ? listItemHeight * 2 : 0;
    // Now, we calculate the height of the scrollable content, with the additional buffer
    // to ensure that all items can be scrolled to be visible given occlusion by the virtual
    // keyboard.
    var itemsHeight = getHeightForItemCount(resultCount);
    return {
        // The height of the scroll view
        viewHeight: isDesktop ? itemsHeight : baseItemsHeight + peekHeight + basePadding,
        // The scrollable content height within the scroll view
        contentHeight: itemsHeight,
    };
};
function getKey(item) {
    switch (item.item.type) {
        case "tag":
            return "".concat(item.item.tag.name, "__tag");
        case "performer":
            return "".concat(item.item.performer.nickname, "__performer");
        // There should only ever be 1 video item
        case "video":
            return "video";
        default:
            return "";
    }
}
var useAutocompleteListItemsStyles = (0, react_jss_1.createUseStyles)({
    labelWrapper: {
        display: "flex",
        paddingInlineStart: "8px",
        marginTop: "4px",
        color: "#9e9e9e",
        marginBottom: "4px",
    },
    lineBreak: {
        marginLeft: "8px",
        marginRight: "8px",
        color: "#e0e0e0",
        borderColor: "#e0e0e0",
        backgroundColor: " #e0e0e0",
        borderBottom: "unset !important",
        height: "2px",
    },
});
function AutoCompleteListItems(_a) {
    var autocompleteResults = _a.autocompleteResults, keyword = _a.keyword, translate = _a.translate, requiresAgeVerification = _a.requiresAgeVerification;
    var classes = useAutocompleteListItemsStyles();
    var results = [];
    function getHeaderType(type) {
        switch (type) {
            case "tag":
                return translate("search.autocomplete.tag");
            case "performer":
                return translate("search.autocomplete.performer");
            case "video":
                return translate("page_titles.videostore");
            default:
                return "";
        }
    }
    var previousHeaderType = "";
    autocompleteResults.forEach(function (result) {
        // This adds the headers where needed
        if (previousHeaderType !== result.item.type) {
            var label = ((0, jsx_runtime_1.jsx)("div", { className: classes.labelWrapper, children: (0, jsx_runtime_1.jsx)("div", { children: getHeaderType(result.item.type) }) }, "".concat(result.item.type, "_label")));
            if (!previousHeaderType) {
                results.push(label);
            }
            else {
                results.push((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("hr", { className: classes.lineBreak }), label] }, "line_break_".concat(result.item.type)));
            }
            previousHeaderType = result.item.type;
        }
        results.push((0, jsx_runtime_1.jsx)(AutocompleteListItem_1.AutocompleteListItem, __assign({}, result, { keyword: keyword, listItemHeight: listItemHeight, requiresAgeVerification: requiresAgeVerification }), getKey(result)));
    });
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: __spreadArray([], __read(results), false) });
}
var AutocompleteListContainer = function (props) {
    var _a, _b;
    var _c = __read((0, Ioc_1.useContexts)(Contexts_1.IThemeContext, Contexts_1.ITranslationServiceContext, Contexts_1.ILayoutContext, Contexts_1.IUserContext), 4), theme = _c[0], translate = _c[1].translate, layout = _c[2], user = _c[3];
    var items = props.items, maxVisibleItems = props.maxVisibleItems, keyword = props.keyword, shouldUseHeaderStyles = props.shouldUseHeaderStyles;
    var breakpoint = layout.breakpoint;
    var requiresAgeVerification = (_b = (((_a = user === null || user === void 0 ? void 0 : user.ageVerificationRules) === null || _a === void 0 ? void 0 : _a.requiresAgeConfirmation) && (!(user === null || user === void 0 ? void 0 : user.isAuthenticated) || (user === null || user === void 0 ? void 0 : user.isFreemium)))) !== null && _b !== void 0 ? _b : true;
    var labelCount = new Set(items.map(function (_a) {
        var item = _a.item;
        return item.type;
    })).size;
    var itemCount = items.length + labelCount;
    var hasResults = itemCount > 0;
    var padding = hasResults ? theme.spacing.base / 2 : 0;
    var listProps = __assign(__assign({ children: undefined }, getLayoutHeights(itemCount, maxVisibleItems !== null && maxVisibleItems !== void 0 ? maxVisibleItems : Number.POSITIVE_INFINITY, padding, breakpoint)), { hasResults: hasResults, maxVisibleItems: maxVisibleItems, width: shouldUseHeaderStyles ? 320 : undefined, theme: theme });
    return ((0, jsx_runtime_1.jsx)(AutocompleteList_1.AutocompleteList, __assign({}, listProps, { children: (0, jsx_runtime_1.jsx)(AutoCompleteListItems, { autocompleteResults: items, keyword: keyword, translate: translate, requiresAgeVerification: requiresAgeVerification }) })));
};
exports.AutocompleteListContainer = AutocompleteListContainer;
exports.AutocompleteListContainer.displayName = "AutocompleteListContainer";
//# sourceMappingURL=AutocompleteListContainer.js.map